<template>
  <div class="page-main">
    <div class="symbol"></div>
    <p class="detail">服务不可用，请与HR联系！</p>
    <p class="company">@点滴关怀公司（2343）</p>
    <a
      class="change-company"
      :href="config.client_domain+'/m/member-change_member_company-1.html'"
    >切换公司</a>
  </div>
</template>
<script>
import config from "../../../../config/config.js";
export default {
  data() {
    return {
      config: null
    };
  },
  created: function() {
    // this.$store.dispatch("loadUserInfo");
    this.config = config;
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/_mixin.scss";
.page-main {
  height: 100vh;
  width: 100%;
  text-align: center;
  background-color: white;
  padding-top: px2rem(267.1875px);
}
.symbol {
  background: url("../../assets/img/service-stop.png") no-repeat;
  background-size: px2rem(150px) px2rem(150px);
  width: px2rem(150px);
  height: px2rem(150px);
  margin: 0 auto 0;
}
.detail {
  margin-top: px2rem(84.375px);
  font-family: PingFangSC-Regular;
  font-size: px2rem(42.1875px);
  color: #000000;
  text-align: center;
}
.company {
  display: none;
  margin-top: px2rem(28.125px);
  font-family: PingFangSC-Regular;
  font-size: px2rem(28.125px);
  color: #000000;
  text-align: center;
}
.change-company {
  display: none;
  border: 1px solid #d2d2d2;
  border-radius: px2rem(4.6875px);
  font-family: PingFangSC-Regular;
  font-size: px2rem(32.8125px);
  color: #2ec9fa;
  text-align: center;
  width: px2rem(255.46875px);
  height: px2rem(98.4375px);
  line-height: px2rem(98.4375px);
  margin: px2rem(84.375px) auto 0;
}
</style>

